import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import { ArrowSquareOut as ArrowSquareOutIcon } from "@phosphor-icons/react/ArrowSquareOut";
import { Plus as PlusIcon } from "@phosphor-icons/react/Plus";
import { UserPlus as UserPlusIcon } from "@phosphor-icons/react/UserPlus";
import { paths } from "config/paths";
import RouterLink from "next/link";
import { useCopyToClipboard } from "usehooks-ts";
import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import { useWebRouter } from "~utils/next-router/use-web-router";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import { Copy } from "@phosphor-icons/react/Copy";
import { toast } from "~ui-components/components/atoms/toaster";
import { UserGroup } from "~ui-components/types/__generated/gql/graphql";
import {
	DatasetAccessForm,
	DatasetAccessFormProps,
} from "./dataset-access-form";

interface DatasetAccessProps {
	form: DatasetAccessFormProps["form"];
	groups: UserGroup[];
	isGroupsLoading: boolean;
	isManageGroupAllowed: boolean;
}

export function DatasetAccess(props: DatasetAccessProps) {
	return (
		<DashboardContentLayout
			pageTitle="Access"
			action={<AccessTopAction {...props} />}>
			<Card>
				<CardHeader
					action={
						<Button
							color="secondary"
							endIcon={<ArrowSquareOutIcon />}>
							Learn more
						</Button>
					}
					avatar={
						<Avatar>
							<UserPlusIcon fontSize="var(--Icon-fontSize)" />
						</Avatar>
					}
					title="Data access"
					subheader="Choose who can view or modify this data"
				/>
				<DatasetAccessForm {...props} />
			</Card>
		</DashboardContentLayout>
	);
}

const AccessTopAction = ({ isManageGroupAllowed }: DatasetAccessProps) => {
	const router = useWebRouter();
	const [, copyToClipboard] = useCopyToClipboard();

	const link = `https://${process.env.ROUTER_DOMAIN_NAME}${paths.accountName.data.datasetId.root(
		router._query.accountName,
		router._query.datasetId,
	)}`;

	return (
		<Stack
			direction="row"
			gap={2}>
			<OutlinedInput
				sx={{
					width: "500px",
				}}
				endAdornment={
					<InputAdornment position="end">
						<IconButton
							onClick={() =>
								toast.promise(copyToClipboard(link), {
									success: "Link copied to clipboard",
									error: "Something went wrong!",
								})
							}>
							<Copy />
						</IconButton>
					</InputAdornment>
				}
				value={link}
			/>
			{isManageGroupAllowed && (
				<div style={{ textWrap: "nowrap" }}>
					<Button
						component={RouterLink}
						startIcon={<PlusIcon />}
						variant="contained"
						href={paths.accountName.groups.root(router._query.accountName)}>
						Add or manage group
					</Button>
				</div>
			)}
		</Stack>
	);
};

export * from "./dataset-access-form";
